import { gql } from '@apollo/client';

export const fetchTransactionAccount = gql`
  query fetchTransactionAccount($id: ID!) {
    transactionAccount(id: $id) {
      id
      transactionAccountNumber
      billToParty {
        name
        addressLine1
        addressLine2
        city
        state
        country
        postcode
        taxId
        taxExempt
      }
      billToPartyPricingEligibilty
      billingAdmins {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          email
          atlassianAccountId
          fullName
        }
      }
      displayName
      isPartner
      status
      availableInvoiceGroups {
        totalCount
        nodes {
          id
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            state
            country
            postcode
            taxId
            taxIds {
              id
              label
            }
          }
          defaultPaymentMethod {
            type
            paymentIssue
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
          }
        }
      }
      availablePaymentMethods {
        totalCount
        nodes {
          id
          type
          default
          paymentIssue
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
            }
          }
        }
      }
      updatePaymentMethodLink
    }
  }
`;
